import { Info, ShieldCheck } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/modules/shared/ui/components/tooltip"

const REQUIREMENTS = [
  "At least 8 characters",
  "One uppercase letter (A–Z)",
  "One lowercase letter (a–z)",
  "One number (0–9)",
  "One special character (!@#$%^&*)",
]

export function PasswordRequirementsTooltip() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Info className="h-3.5 w-3.5 text-muted-foreground cursor-help shrink-0" />
      </TooltipTrigger>
      <TooltipContent
        side="top"
        className="max-w-[260px] p-0 overflow-hidden"
      >
        <div className="px-3.5 py-2.5 space-y-1.5">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-3.5 h-3.5 shrink-0 text-primary" />
            <span className="text-[13px] font-semibold text-white leading-tight">
              Password requirements
            </span>
          </div>
          <ul className="text-[11px] leading-relaxed text-white list-disc pl-4 space-y-0.5">
            {REQUIREMENTS.map((r) => (
              <li key={r}>{r}</li>
            ))}
          </ul>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
